export enum JobType {
    CountBasedJob = 1,
    QuickHaul = 2
}



// WEBPACK FOOTER //
// ./src/types/enums/JobType.ts